const TRAILING_FLOOR_NON_TRIGGER_FIELDS = new Set(['floorPrice', 'listPrice']);

export const shouldSyncTrailingFloorPrice = ({
  hasTrailingFloor,
  isLocalRule,
  filtersDirty,
  formValues,
  isFieldDirty,
}: {
  hasTrailingFloor: boolean;
  isLocalRule: boolean;
  filtersDirty: boolean;
  formValues: Record<string, unknown>;
  isFieldDirty: (field: string) => boolean;
}) => {
  if (!hasTrailingFloor) {
    return false;
  }

  if (isLocalRule || filtersDirty) {
    return true;
  }

  return Object.keys(formValues).some((field) => !TRAILING_FLOOR_NON_TRIGGER_FIELDS.has(field) && isFieldDirty(field));
};
